import { CreditUsageType, Maybe } from '@aibees/shared/definition';
import { useCreditUsageItem } from '@aibees/shared/hooks';
import { useMemo } from 'react';

export function useCalculateAiPersonalityCredits(meetings: Maybe<number>) {
  const { credit } = useCreditUsageItem(
    CreditUsageType.CONTACT_ANALYSIS_REVEAL
  );
  return useMemo(() => (meetings ?? 0) * credit, [meetings, credit]);
}
